export default __webpack_public_path__ + "static/media/bg-pubg-1.2e57581e.png";